import { styled } from '@mui/material/styles';
import { Dialog } from '@mui/material';
import { COLOR } from '@src/styles/color';

export const StyledCreateCreditModal = styled(Dialog)`
  .MuiDialog-paper {
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    min-width: 1000px;
    max-width: 1200px;
    max-height: 95vh;
    overflow: hidden;
    border-radius: 12px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  }

  .dialog-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    padding: 24px 32px 16px;
    color: ${COLOR.text.primary};
    border-radius: 12px 12px 0 0;
    margin: 0;

    .MuiIconButton-root {
      color: ${COLOR.text.primary};
      padding: 8px;

      &:hover {
        background-color: ${COLOR.charcoal[8]};
      }
    }
  }

  .dialog-content {
    padding: 24px 32px;
    flex: 1;
    overflow-y: auto;
    background: linear-gradient(
      145deg,
      ${COLOR.white[100]} 0%,
      ${COLOR.charcoal[4]} 100%
    );
  }

  .form-section {
    margin-bottom: 32px;
    padding: 20px;
    border: 1px solid ${COLOR.charcoal[16]};
    border-radius: 8px;
    background: linear-gradient(
      145deg,
      ${COLOR.white[100]} 0%,
      ${COLOR.charcoal[4]} 100%
    );

    &:hover {
      border-color: ${COLOR.primary.light};
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    }
  }

  .section-title {
    color: ${COLOR.text.primary};
    font-weight: 600;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 2px solid ${COLOR.primary.light};
  }

  .field-label {
    color: ${COLOR.text.primary};
    font-weight: 500;
    margin-bottom: 8px;
    font-size: 14px;

    .required {
      color: ${COLOR.error.main};
      margin-left: 4px;
    }
  }

  .tool-search-container {
    position: relative;
  }

  .tool-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 1000;
    background: white;
    border: 1px solid ${COLOR.charcoal[32]};
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    max-height: 200px;
    overflow-y: auto;
    margin-top: 4px;
  }

  .tool-option {
    padding: 12px 16px;
    cursor: pointer;
    border-bottom: 1px solid ${COLOR.charcoal[8]};
    transition: background-color 0.2s;

    &:hover {
      background-color: ${COLOR.primary[8]};
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .tool-option.selected {
    background-color: ${COLOR.primary[8]};
    color: ${COLOR.primary.dark};
  }

  .MuiDialogActions-root {
    padding: 16px 32px 24px;
    background: ${COLOR.white[100]};
    border-top: 1px solid ${COLOR.charcoal[16]};

    .MuiButton-root {
      text-transform: none;
      font-weight: 600;
      padding: 10px 24px;
      border-radius: 8px;

      &.MuiButton-contained {
        background: linear-gradient(
          135deg,
          ${COLOR.primary.main} 0%,
          ${COLOR.primary.dark} 100%
        );

        &:hover {
          background: linear-gradient(
            135deg,
            ${COLOR.primary.dark} 0%,
            ${COLOR.primary.main} 100%
          );
        }

        &:disabled {
          background: ${COLOR.charcoal[32]};
          color: ${COLOR.text.disabled};
        }
      }

      &.MuiButton-text {
        color: ${COLOR.text.secondary};

        &:hover {
          background-color: ${COLOR.charcoal[8]};
        }
      }
    }
  }
`;

export const StyledDetailCreditModal = styled(Dialog)`
  .MuiDialog-paper {
    padding: 0 !important;
    display: flex;
    flex-direction: column;
    min-width: 1000px;
    max-width: 1200px;
    max-height: 95vh;
    overflow: hidden;
    border-radius: 12px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  }

  .dialog-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    padding: 24px 32px 16px;
    color: ${COLOR.text.primary};
    border-radius: 12px 12px 0 0;
    margin: 0;

    .mode-toggle {
      display: flex;
      align-items: center;
      gap: 12px;

      .MuiButton-root {
        text-transform: none;
        font-weight: 600;
        padding: 8px 16px;
        border-radius: 6px;

        &.MuiButton-contained {
          background: ${COLOR.primary.base};
          color: white;
          border: 1px solid ${COLOR.primary.base};

          &:hover {
            background: ${COLOR.primary.dark};
          }
        }

        &.MuiButton-outlined {
          background: transparent;
          color: ${COLOR.primary.base};
          border: 1px solid ${COLOR.primary.base};

          &:hover {
            background: ${COLOR.primary[8]};
            border-color: ${COLOR.primary.dark};
          }
        }
      }
    }

    .MuiIconButton-root {
      color: ${COLOR.text.primary};
      padding: 8px;

      &:hover {
        background-color: ${COLOR.charcoal[8]};
      }
    }
  }

  .dialog-content {
    padding: 24px 32px;
    flex: 1;
    overflow-y: auto;
    background: linear-gradient(
      145deg,
      ${COLOR.white[100]} 0%,
      ${COLOR.charcoal[4]} 100%
    );
  }

  .form-section {
    margin-bottom: 32px;
    padding: 20px;
    border: 1px solid ${COLOR.charcoal[16]};
    border-radius: 8px;
    background: linear-gradient(
      145deg,
      ${COLOR.white[100]} 0%,
      ${COLOR.charcoal[4]} 100%
    );

    &:hover {
      border-color: ${COLOR.primary.light};
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    }
  }

  .section-title {
    color: ${COLOR.text.primary};
    font-weight: 600;
    margin-bottom: 16px;
    padding-bottom: 8px;
    border-bottom: 2px solid ${COLOR.primary.light};
  }

  .field-label {
    color: ${COLOR.text.primary};
    font-weight: 500;
    margin-bottom: 8px;
    font-size: 14px;

    .required {
      color: ${COLOR.error.main};
      margin-left: 4px;
    }
  }

  .view-content {
    min-height: 40px;
    padding: 12px 16px;
    border: 1px solid ${COLOR.charcoal[32]};
    border-radius: 8px;
    background: linear-gradient(
      145deg,
      ${COLOR.white[100]} 0%,
      ${COLOR.charcoal[4]} 100%
    );
    display: flex;
    align-items: center;
    transition: all 0.2s;

    &:hover {
      border-color: ${COLOR.primary.light};
      background: linear-gradient(
        145deg,
        ${COLOR.white[100]} 0%,
        ${COLOR.primary[4]} 100%
      );
    }

    .view-text {
      color: ${COLOR.text.primary};
      font-weight: 500;
      font-size: 14px;
      word-break: break-word;
    }
  }

  .tool-search-container {
    position: relative;
  }

  .tool-dropdown {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 1000;
    background: white;
    border: 1px solid ${COLOR.charcoal[32]};
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    max-height: 200px;
    overflow-y: auto;
    margin-top: 4px;
  }

  .tool-option {
    padding: 12px 16px;
    cursor: pointer;
    border-bottom: 1px solid ${COLOR.charcoal[8]};
    transition: background-color 0.2s;

    &:hover {
      background-color: ${COLOR.primary[8]};
    }

    &:last-child {
      border-bottom: none;
    }
  }

  .tool-option.selected {
    background-color: ${COLOR.primary[8]};
    color: ${COLOR.primary.dark};
  }

  .MuiDialogActions-root {
    padding: 16px 32px 24px;
    background: ${COLOR.white[100]};
    border-top: 1px solid ${COLOR.charcoal[16]};

    .MuiButton-root {
      text-transform: none;
      font-weight: 600;
      padding: 10px 24px;
      border-radius: 8px;

      &.MuiButton-contained {
        background: linear-gradient(
          135deg,
          ${COLOR.primary.main} 0%,
          ${COLOR.primary.dark} 100%
        );

        &:hover {
          background: linear-gradient(
            135deg,
            ${COLOR.primary.dark} 0%,
            ${COLOR.primary.main} 100%
          );
        }

        &:disabled {
          background: ${COLOR.charcoal[32]};
          color: ${COLOR.text.disabled};
        }
      }

      &.MuiButton-text {
        color: ${COLOR.text.secondary};

        &:hover {
          background-color: ${COLOR.charcoal[8]};
        }
      }
    }
  }
`;
